import React from 'react';
import { FormattedMessage } from 'react-intl';

import { contactUs } from '@/assets/img';
import { CONTACTS } from '@/constants';

import {
  AboutSectionTitle,
  ContactsBlock,
  ContactsUs,
  ContactsWrapper,
  Mail,
  StyledImg,
  StyledTitle,
} from './ContactUs.styles';

function ContactUs() {
  return (
    <ContactsUs id="contactUs" className="sections">
      <ContactsWrapper>
        <StyledTitle>
          <FormattedMessage id="staticContent.anchorLinks.map.title.contactUs" />
        </StyledTitle>
        <StyledImg src={contactUs} alt="contacts image" />
        <ContactsBlock>
          <AboutSectionTitle>
            <FormattedMessage id="staticContent.contacts.mailTitle" />
          </AboutSectionTitle>

          <Mail href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</Mail>
        </ContactsBlock>
      </ContactsWrapper>
    </ContactsUs>
  );
}

export default ContactUs;
